import React from "react";

interface IconBlocksProps {
  width?: number;
  height?: number;
  color?: string;
  className?: string;
}

function IconBlocks({
  width = 20,
  height = 11,
  color = "#6D7878",
  className
}: IconBlocksProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 7C20 8.10457 19.1046 9 18 9H12.1553C11.9749 9.24299 11.7682 9.47192 11.5352 9.68164C10.5975 10.5255 9.32606 11 8 11C6.67394 11 5.40252 10.5255 4.46484 9.68164C4.23182 9.47192 4.02511 9.24299 3.84473 9H2C0.895431 9 0 8.10457 0 7V2C0 0.895431 0.895431 1.61064e-08 2 0H5.06152C5.09977 0.156041 5.15506 0.30926 5.22852 0.457031C5.37928 0.760219 5.60043 1.03551 5.87891 1.26758C6.15738 1.49963 6.48776 1.68394 6.85156 1.80957C7.21554 1.93521 7.60603 2 8 2C8.39397 2 8.78446 1.93521 9.14844 1.80957C9.51224 1.68394 9.84262 1.49963 10.1211 1.26758C10.3996 1.03551 10.6207 0.760219 10.7715 0.457031C10.8449 0.30926 10.9002 0.156041 10.9385 0H18C19.1046 0 20 0.895431 20 2V7ZM12.1553 2C11.9749 2.24299 11.7682 2.47192 11.5352 2.68164C10.5975 3.52553 9.32606 4 8 4C6.67394 4 5.40252 3.52553 4.46484 2.68164C4.23182 2.47192 4.02511 2.24299 3.84473 2H2V7H5.17285C5.19022 7.04986 5.20826 7.09954 5.22852 7.14844C5.37928 7.51226 5.60043 7.84262 5.87891 8.12109C6.15738 8.39957 6.48774 8.62072 6.85156 8.77148C7.21554 8.92225 7.60603 9 8 9C8.39397 9 8.78446 8.92225 9.14844 8.77148C9.51226 8.62072 9.84262 8.39957 10.1211 8.12109C10.3996 7.84262 10.6207 7.51226 10.7715 7.14844C10.7917 7.09954 10.8098 7.04986 10.8271 7H18V2H12.1553Z"
        fill={color}
      />
    </svg>
  );
}

export default IconBlocks;